var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurbine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6629 14.5875L20.2629 18.225C22.0254 16.45 20.2629 14.6875 20.2629 14.6875L18.4004 12.8C18.6254 12.325 18.7504 11.8 18.7504 11.25C18.7504 9.93754 18.0754 8.78754 17.0504 8.12504L18.7504 2.63754C16.3629 1.91254 15.6254 4.30004 15.6254 4.30004L14.6129 7.53754C13.0754 7.70004 11.8254 8.75004 11.4129 10.225L5.83789 12.0375C6.63789 14.4125 9.00039 13.625 9.00039 13.625L11.5879 12.7875C12.0129 13.7125 12.7879 14.425 13.7504 14.775V23.75C13.7504 23.75 11.2504 23.75 11.2504 26.25C11.2504 26.875 11.2504 27.2625 11.2504 27.5H18.7504V26.25C18.7504 26.25 18.7504 23.75 16.2504 23.75V14.775C16.4004 14.725 16.5379 14.65 16.6629 14.5875ZM13.1254 11.25C13.1254 10.7528 13.3229 10.2758 13.6746 9.92422C14.0262 9.57259 14.5031 9.37504 15.0004 9.37504C15.4977 9.37504 15.9746 9.57259 16.3262 9.92422C16.6778 10.2758 16.8754 10.7528 16.8754 11.25C16.8754 11.7473 16.6778 12.2242 16.3262 12.5759C15.9746 12.9275 15.4977 13.125 15.0004 13.125C14.5031 13.125 14.0262 12.9275 13.6746 12.5759C13.3229 12.2242 13.1254 11.7473 13.1254 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurbine);
export default __webpack_public_path__ + "static/media/turbine.92d93d2279de891fee197fa86e54fb8e.svg";
export { ForwardRef as ReactComponent };